



const config = {
    api: {
        about: "/.netlify/functions/about",
        email: "/.netlify/functions/email",
        education: "/.netlify/functions/education",
        experience: "/.netlify/functions/experience",
        projects: "/.netlify/functions/projects",
        resume: "/.netlify/functions/resume"
    },
};

module.exports = config;
